import React, {useEffect, useState} from "react";
import {Link as RouterLink, useSearchParams} from "react-router-dom";
import {Box, Button, Pagination, Paper, Stack} from "@mui/material";
import {EventList} from "../../components/event/EventList";
import {EventPageinatedResponse} from "../../data/events/EventPageinatedResponse";
import useUser from "../../hooks/useUser";

export const EventListingPage = () => {
    const [searchParams, setSearchParams] = useSearchParams()
    const page = parseInt(searchParams.get("page") ?? "1")
    const [eventListings, setEventListings] = useState<EventPageinatedResponse>({
        totalEvents: 1,
        totalPages: 1,
        events: []
    })
    const user = useUser()

    const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
        searchParams.set("page", value.toString())
        setSearchParams(searchParams)
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`/api/event/${page}`)
                const data = await response.json()
                setEventListings(data)
            } catch (error) {
                console.error('Error fetching events:', error)
            }
        };
        fetchData()
    }, [page])

    const totalPages = eventListings.totalPages

    return <Stack spacing={1}>
        <Paper variant={"outlined"} style={{
            marginTop: "16px",
            padding: "16px"
        }}>
            <EventList events={eventListings.events} canCreateEvents={user.user?.permissions.find((T) => {
                return T.includes("-events:create")
            }) !== undefined } />
            <Button component={RouterLink} to={`/events/archive`} color="info">View Archive</Button>
        </Paper>
        <Box sx={{justifyContent: "center", display: "flex", width: "100%", mt: 2}}>
            <Pagination color={'secondary'} count={totalPages} page={page} onChange={handleChange}/>
        </Box>
    </Stack>
}